import { createReducer, on, Action } from '@ngrx/store';
import * as UserDetailsActions from './user.action';
import * as fromUserPermissions from "./userPermission.adapter";
import { Update } from '@ngrx/entity';
import { IPermissionMapping } from 'src/app/models/user';

const permissionMappingReducer = createReducer(fromUserPermissions.intialPermissionMappingState,
  on(UserDetailsActions.SuccessGetUserPermissionApiAction, (state, { permissions }) => {
    return fromUserPermissions.PermissionMappingAdapter.setAll(permissions, state);
  }), on(UserDetailsActions.SuccessGetUserPermissionApiAction, (state, { permissions }) => {
    return { ...state, isLoaded: true };
  }),
  on(UserDetailsActions.SuccessPostUserDetailsApiAction, (state, { userDetails }) => {
    return fromUserPermissions.PermissionMappingAdapter.setAll(userDetails.payload.permissionMapping, state);
  }), on(UserDetailsActions.SuccessPostUserDetailsApiAction, (state) => {
    return { ...state, isLoaded: true };
  }),
  on(UserDetailsActions.SuccessGetUserDetailsApiAction, (state, { userDetails }) => {
    return fromUserPermissions.PermissionMappingAdapter.setAll(userDetails.payload.permissionMapping, state);
  }), on(UserDetailsActions.SuccessGetUserDetailsApiAction, (state) => {
    return { ...state, isLoaded: true };
  }),
  on(UserDetailsActions.UpdateUserPermissionMappingAction, (state, payload: Update<IPermissionMapping>) => {
    return fromUserPermissions.PermissionMappingAdapter.updateOne(payload, state);
  })
);

export function PermissionMappingReducer(state: fromUserPermissions.PermissionMappingState | undefined, action: Action) {
  return permissionMappingReducer(state, action);
}
